import "./ui/styles.css";
import "./ui/vd-theme.css";
import "./ui/profile.css";
import "./ui/online.css";
import { startServerNotice } from "@act/client-core/notice";
import { resolveColyseusEndpoint } from "@act/client-core/network";
import { Game } from "./core/Game";

const canvas = document.getElementById("renderCanvas") as HTMLCanvasElement;
const container = document.getElementById("app") as HTMLElement;

if (!canvas || !container) {
  throw new Error("DRIFTRACER: missing #renderCanvas or #app in the DOM");
}

// Kick off the game. Everything (menu, race, HUD) lives inside Game.
// /builder opens the same app on the track builder, which isn't in the game's menu.
const game = new Game(canvas, container, document.documentElement.dataset.page === "builder");

// The ACT update warning (platform DR-0098): a red bar counting down to a server reset. It goes in #app, the
// element that goes full screen, so it stays seen.
startServerNotice({ endpoint: resolveColyseusEndpoint(), mount: container });

// Best-effort: keep the device awake during a session if supported.
if ("wakeLock" in navigator) {
  const requestWakeLock = () =>
    (navigator as unknown as { wakeLock: { request: (t: string) => Promise<unknown> } }).wakeLock
      .request("screen")
      .catch(() => {});
  requestWakeLock();
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "visible") requestWakeLock();
  });
}

// Expose for quick debugging in the console during development.
(window as unknown as { game: Game }).game = game;
